// extracted by mini-css-extract-plugin
export default {"coverLink":"ZK-z","contentBox":"_K-z","zapposPromoContainer":"aL-z","zapposPromoGroupContainer":"bL-z","promos":"cL-z","bottom":"dL-z","top":"eL-z","right":"fL-z","left":"gL-z"};